import PropTypes from "prop-types";
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";

// the selectable model file formats and their user-facing descriptions.
const FORMAT_INFO = {
  stl: { name: "STL", description: "3D model without color" },
  obj: { name: "OBJ", description: "3D model with color texture" },
};

// The dashboard's Settings dialog. Currently it holds a single setting: the
// model file format to upload, picked among the ones the customer accepts.
export const SettingsDialog = (props) => {
  const { open, onClose, fileFormats, fileFormat, onFileFormatChange } = props;

  return (
    <Dialog open={open} onClose={onClose} sx={{ zIndex: 1500 }}>
      <DialogTitle>Settings</DialogTitle>
      <DialogContent>
        <FormControl>
          <FormLabel id="file-format-label">
            File format of the uploaded models
          </FormLabel>
          <RadioGroup
            aria-labelledby="file-format-label"
            value={fileFormat}
            onChange={(event) => onFileFormatChange(event.target.value)}
            sx={{ mt: 1, gap: 1 }}
          >
            {fileFormats.map((format) => {
              const info = FORMAT_INFO[format];
              return (
                <FormControlLabel
                  key={format}
                  value={format}
                  control={<Radio />}
                  label={
                    <>
                      <Typography>
                        {info ? info.name : format.toUpperCase()}
                      </Typography>
                      {info && (
                        <Typography variant="body2" color="text.secondary">
                          {info.description}
                        </Typography>
                      )}
                    </>
                  }
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
};

SettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fileFormats: PropTypes.arrayOf(PropTypes.string).isRequired,
  fileFormat: PropTypes.string.isRequired,
  onFileFormatChange: PropTypes.func.isRequired,
};
